<div *ngIf="appBusyState"
     [ngSwitch]="!!appBusyState.templatePortal">
    <div class="app-busy">
        <ng-container *ngSwitchCase="true"
                      [cdkPortalOutlet]="appBusyState.templatePortal"></ng-container>
        <p class="center"
           *ngSwitchCase="false">
            {{appBusyState.message}}
        </p>
    </div>
</div>